import * as React from 'react'
import { SVGProps } from 'react'

const ErrosComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={17}
        height={17}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.5 8.146v3.541m0-6.367.007-.008M8.5 15.583a7.083 7.083 0 1 0 0-14.166 7.083 7.083 0 0 0 0 14.166Z"
            stroke="#DF0209"
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default ErrosComponent
